export function cs(...items: (string | Record<string, unknown> | undefined)[]) {
  const classNamesList: string[] = [];
  return items.reduce((memo, item) => {
    if (!item) return memo;
    if (typeof item === "string") {
      memo.push(item);
    } else {
      const truthyClassNames = Object.entries(item)
        .filter(([, val]) => !!val)
        .map(([key]) => key);
      memo.push(...truthyClassNames);
    }
    return memo;
  }, classNamesList).join(' ');
}
